module.exports = __webpack_public_path__ + "images/ms-screen-icon-3cbc172d.svg";